"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBindingConstraintsWithName = isBindingConstraintsWithName;
function isBindingConstraintsWithName(name) {
    return (constraints) => constraints.name === name;
}
//# sourceMappingURL=isBindingConstraintsWithName.js.map